import { defineComponent as i, openBlock as o, createElementBlock as l, mergeProps as u, unref as e, renderSlot as A, createElementVNode as n, createCommentVNode as g } from "vue";
import { useScalarIcon as m } from "../hooks/useScalarIcon.js";
const f = { key: 0 }, H = { key: 1 }, V = { key: 2 }, k = { key: 3 }, v = { key: 4 }, w = { key: 5 }, L = {
  name: "ScalarIconArrowArcLeft"
}, h = /* @__PURE__ */ i({
  ...L,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: a } = m(s);
    return (p, t) => (o(), l("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(d)), [
      A(p.$slots, "default"),
      e(a) === "bold" ? (o(), l("g", f, t[0] || (t[0] = [
        n("path", { d: "M236,184a12,12,0,0,1-24,0A84,84,0,0,0,68.6,124.6L53.11,140H88a12,12,0,0,1,0,24H24a12,12,0,0,1-12-12V88a12,12,0,0,1,24,0v35.16l15.66-15.55A108,108,0,0,1,236,184Z" }, null, -1)
      ]))) : e(a) === "duotone" ? (o(), l("g", H, t[1] || (t[1] = [
        n("path", {
          d: "M88,152H24V88Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M201.54,110.46a104,104,0,0,0-145.4-1.63L29.66,82.34A8,8,0,0,0,16,88v64a8,8,0,0,0,8,8H88a8,8,0,0,0,5.66-13.66L67.47,120.16A88,88,0,0,1,216,184a8,8,0,0,0,16,0A103.33,103.33,0,0,0,201.54,110.46ZM32,144V107.31L68.69,144Z" }, null, -1)
      ]))) : e(a) === "fill" ? (o(), l("g", V, t[2] || (t[2] = [
        n("path", { d: "M232,184a8,8,0,0,1-16,0A88,88,0,0,0,67.47,120.16l26.19,26.18A8,8,0,0,1,88,160H24a8,8,0,0,1-8-8V88a8,8,0,0,1,13.66-5.66l26.48,26.48A104,104,0,0,1,232,184Z" }, null, -1)
      ]))) : e(a) === "light" ? (o(), l("g", k, t[3] || (t[3] = [
        n("path", { d: "M230,184a6,6,0,0,1-12,0A90,90,0,0,0,64.36,120.36L38.55,146H88a6,6,0,0,1,0,12H24a6,6,0,0,1-6-6V88a6,6,0,0,1,12,0v49.58l25.89-25.72A102,102,0,0,1,230,184Z" }, null, -1)
      ]))) : e(a) === "regular" ? (o(), l("g", v, t[4] || (t[4] = [
        n("path", { d: "M232,184a8,8,0,0,1-16,0A88,88,0,0,0,65.78,121.78L43.4,144H88a8,8,0,0,1,0,16H24a8,8,0,0,1-8-8V88a8,8,0,0,1,16,0v44.77l22.48-22.33A104,104,0,0,1,232,184Z" }, null, -1)
      ]))) : e(a) === "thin" ? (o(), l("g", w, t[5] || (t[5] = [
        n("path", { d: "M228,184a4,4,0,0,1-8,0A92,92,0,0,0,63,119L33.7,148H88a4,4,0,0,1,0,8H24a4,4,0,0,1-4-4V88a4,4,0,0,1,8,0v54.39l29.3-29.11A100,100,0,0,1,228,184Z" }, null, -1)
      ]))) : g("", !0)
    ], 16));
  }
});
export {
  h as default
};
